<div class="table-container">
  <table aria-label="Stationen" mat-table [dataSource]="stations" [trackBy]="trackByStationId">
    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td
        mat-cell
        *matCellDef="let station"
        [class.verticalAlignNoSenor]="station.sensors.length === 0"
      >
        <mat-cell
          class="status-cell"
          [class.sensorHeadline]="station.sensors.length === 0"
        >
          <mat-icon class="status" [ngClass]="station.stationStatus"
            >circle</mat-icon
          >
        </mat-cell>
      </td>
    </ng-container>
    <ng-container matColumnDef="stationId">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td
        mat-cell
        *matCellDef="let station"
        [class.verticalAlignNoSenor]="station.sensors.length === 0"
      >
        <mat-cell
          [class.sensorHeadline]="station.sensors.length === 0"
          (click)="
            openStationDetails(station.stationId, storedCurrentPageSize, pageNo)
          "
        >
          <div [id]="station.stationId" class="clickableId">
            {{ station.stationId }}
          </div>
        </mat-cell>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td
        mat-cell
        *matCellDef="let station"
        [class.verticalAlignNoSenor]="station.sensors.length === 0"
      >
        <mat-cell [class.sensorHeadline]="station.sensors.length === 0">
          <div class="station-name-cell">{{ station.name }}</div>
        </mat-cell>
        <div class="station-additional-info-row"
             *ngIf="station.additionalInfo?.length">
          {{ station.additionalInfo }}
        </div>
      </td>
    </ng-container>
    <ng-container *ngIf="hasRequiredRole(role.regionaloffice_view)">
      <ng-container matColumnDef="regionalOffice">
        <th mat-header-cell *matHeaderCellDef>BD/NL</th>
        <td
          mat-cell
          *matCellDef="let station"
          [class.verticalAlignNoSenor]="station.sensors.length === 0"
        >
          <mat-cell [class.sensorHeadline]="station.sensors.length === 0">
            {{ station.regionalOfficeRepresentation.name }}
          </mat-cell>
        </td>
      </ng-container>
      <ng-container matColumnDef="contactPerson">
        <th mat-header-cell *matHeaderCellDef>Ansprechpartner</th>
        <td
          mat-cell
          *matCellDef="let station"
          [class.verticalAlignNoSenor]="station.sensors.length === 0"
        >
          <mat-cell [class.sensorHeadline]="station.sensors.length === 0">
            {{ station.contactPerson }}
          </mat-cell>
        </td>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="hasRequiredRole(role.sensor_view)">
      <ng-container matColumnDef="sensorId">
        <th mat-header-cell *matHeaderCellDef>SensorId</th>
        <td
          class="sensors"
          mat-cell
          *matCellDef="let station"
          [class.verticalAlignNoSenor]="station.sensors.length === 0"
        >
          <mat-cell
            [class.sensorHeadline]="station.sensors.length === 0"
          ></mat-cell>
          <div
            class="sensor-grid sensor-grid--id"
            *ngIf="station.sensors.length > 0"
          >
            <ng-container
              *ngFor="
                let sensorRow of getSensorRows(station); trackBy: trackBySensorRow
              "
            >
              <div
                *ngIf="!sensorRow.isContinuation"
                class="sensor-grid__cell sensor-grid__cell--id"
                [class.sensor-grid__cell--empty]="!sensorRow.displayId"
                [style.gridRowEnd]="
                  sensorRow.groupSpan > 1 ? 'span ' + sensorRow.groupSpan : undefined
                "
              >
                {{ sensorRow.displayId }}
              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="battery">
        <th mat-header-cell *matHeaderCellDef>Batterie</th>
        <td
          class="innerTabelCell"
          mat-cell
          *matCellDef="let station"
          [class.verticalAlignNoSenor]="station.sensors.length === 0"
        >
          <mat-cell
          [class.sensorHeadline]="station.sensors.length === 0"
          ></mat-cell>
          <div
            class="sensor-grid"
            *ngIf="station.sensors.length > 0"
          >
            <div
              class="sensor-grid__cell sensor-value-cell"
              *ngFor="
                let sensorRow of getSensorRows(station); trackBy: trackBySensorRow
              "
              [ngClass]="sensorRow.sensor.batteryState"
            >
              {{ sensorRow.sensor.validBatteryCapacity }} /
              {{ sensorRow.sensor.maximumBatteryCapacity }}
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="sensorType">
        <th mat-header-cell *matHeaderCellDef>Parameter</th>
        <td
          class="sensors"
          mat-cell
          *matCellDef="let station"
          [class.verticalAlignNoSenor]="station.sensors.length === 0"
        >
          <mat-cell
          [class.sensorHeadline]="station.sensors.length === 0"
          ></mat-cell>
          <div
            class="sensor-grid"
            *ngIf="station.sensors.length > 0"
          >
            <div
              class="sensor-grid__cell sensor-value-cell"
              *ngFor="
                let sensorRow of getSensorRows(station); trackBy: trackBySensorRow
              "
            >
              {{ sensorRow.sensor.sensorShortCut | sensorPipe }}
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="sensorTransmissionSignal">
        <th mat-header-cell *matHeaderCellDef>Übertragungssignal</th>
        <td
          class="sensors"
          mat-cell
          *matCellDef="let station"
          [class.verticalAlignNoSenor]="station.sensors.length === 0"
        >
          <div>
            <mat-cell
              [class.sensorHeadline]="station.sensors.length === 0"
            ></mat-cell>
            <div
              class="sensor-grid"
              *ngIf="station.sensors.length > 0"
            >
              <div
                class="sensor-grid__cell sensor-value-cell"
                *ngFor="
                  let sensorRow of getSensorRows(station); trackBy: trackBySensorRow
                "
                [ngClass]="sensorRow.sensor.transmissionSignal"
              ></div>
            </div>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="statusComment">
        <th mat-header-cell *matHeaderCellDef>Status-Hinweis</th>
        <td
          class="sensors"
          mat-cell
          *matCellDef="let station"
          [class.verticalAlignNoSenor]="station.sensors.length === 0"
        >
          <mat-cell
            [class.sensorHeadline]="station.sensors.length === 0"
          ></mat-cell>
          <div
            class="sensor-grid"
            *ngIf="station.sensors.length > 0"
          >
            <div
              class="sensor-grid__cell sensor-value-cell statusComment"
              *ngFor="
                let sensorRow of getSensorRows(station); trackBy: trackBySensorRow
              "
            >
              <mat-select
                [disabled]="!hasRequiredRole(role.status_hint_edit)"
                [value]="
                  sensorRow.sensor.sensorStatus.statusComment | getStatusCommentValue
                "
                (selectionChange)="
                  setStatusComment(
                    $event.value,
                    station.stationId,
                    sensorRow.sensor
                  )
                "
              >
                <mat-option
                  *ngFor="let comment of statusComments"
                  [value]="comment"
                >
                  {{ comment }}
                </mat-option>
              </mat-select>
              <div class="statusCommentDate">
                {{ sensorRow.sensor.sensorStatus.startDate | parseDate }}
              </div>
            </div>
          </div>
        </td>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="hasRequiredRole(role.notice_view)" matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef>Notiz</th>
      <td class="sensors" mat-cell *matCellDef="let station">
        <mat-cell>
          <div *ngIf="station.note; else emptyPageIcon" class="existingRemark">
            <img
              (click)="
                openDialogNoteStation(
                  station,
                  hasRequiredRole(role.notice_edit)
                )
              "
              [id]="'station-note-' + station.stationId"
              src="assets/icons8Note.png"
              alt="Paper Note"
              style="width: 2em"
              [matTooltip]="station.note.text"
            />
            <ng-container *ngIf="hasRequiredRole(role.notice_delete)">
              <img
                (click)="archiveRemarkNoteOnStation(station)"
                src="assets/icons8-trash-96.png"
                alt="Trash/Delete"
                style="width: 2em; margin-left: 0.2em"
                [matTooltip]="'Notiz löschen'"
              />
            </ng-container>
          </div>
          <ng-template #emptyPageIcon>
            <ng-container *ngIf="hasRequiredRole(role.notice_edit)">
              <img
                (click)="createNoteOnStation(station)"
                [id]="'station-note-' + station.stationId"
                src="assets/icons8NoteEmpty.png"
                alt="Paper Note"
                style="width: 2em"
                [matTooltip]="'Notiz erstellen'"
              />
            </ng-container>
          </ng-template>
        </mat-cell>
        <ng-container *ngIf="hasRequiredRole(role.sensor_view)">
          <div
            class="sensor-grid"
            *ngIf="station.sensors.length > 0"
          >
            <div
              class="sensor-grid__cell sensor-value-cell"
              *ngFor="
                let sensorRow of getSensorRows(station); trackBy: trackBySensorRow
              "
            >
              <div
                *ngIf="sensorRow.sensor.note; else emptyNoteIcon"
                class="existingRemark"
              >
                <img
                  (click)="
                    openDialogNoteSensor(
                      sensorRow.sensor,
                      station.stationId,
                      hasRequiredRole(role.notice_edit)
                    )
                  "
                  [id]="'sensor-note-' + sensorRow.sensor.sensorType"
                  src="assets/icons8Note.png"
                  alt="Paper Note"
                  style="width: 2em"
                  [matTooltip]="sensorRow.sensor.note.text"
                />
                <ng-container *ngIf="hasRequiredRole(role.notice_delete)">
                  <img
                    (click)="archiveRemarkNoteOnSensor(sensorRow.sensor)"
                    src="assets/icons8-trash-96.png"
                    alt="Trash/Delete"
                    style="width: 2em; margin-left: 0.2em"
                    [matTooltip]="'Notiz löschen'"
                  />
                </ng-container>
              </div>
              <ng-template #emptyNoteIcon>
                <ng-container *ngIf="hasRequiredRole(role.notice_edit)">
                  <img
                    (click)="createNoteOnSensor(sensorRow.sensor, station.stationId)"
                    [id]="'sensor-note-' + sensorRow.sensor.sensorType"
                    src="assets/icons8NoteEmpty.png"
                    alt="Paper Note"
                    style="width: 2em"
                    [matTooltip]="'Notiz erstellen'"
                  />
                </ng-container>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </td>
    </ng-container>
    <ng-container
      *ngIf="hasRequiredRole(role.comment_view)"
      matColumnDef="comment"
    >
      <th mat-header-cell *matHeaderCellDef>Kommentar</th>
      <td class="sensors" mat-cell *matCellDef="let station">
        <mat-cell>
          <div
            *ngIf="station.comment; else emptyPageIcon"
            class="existingRemark"
          >
            <img
              (click)="
                openDialogCommentStation(
                  station,
                  hasRequiredRole(role.comment_edit)
                )
              "
              [id]="'station-comment-' + station.stationId"
              src="assets/icons8Note.png"
              alt="Paper Note"
              style="width: 2em"
              [matTooltip]="station.comment.text"
            />
            <ng-container *ngIf="hasRequiredRole(role.comment_delete)">
              <img
                (click)="archiveRemarkCommentStation(station)"
                src="assets/icons8-trash-96.png"
                alt="Trash/Delete"
                style="width: 2em; margin-left: 0.2em"
                [matTooltip]="'Kommentar löschen'"
              />
            </ng-container>
          </div>
          <ng-template #emptyPageIcon>
            <ng-container *ngIf="hasRequiredRole(role.comment_edit)">
              <img
                (click)="openDialogCommentStation(station)"
                [id]="'station-note-' + station.stationId"
                src="assets/icons8NoteEmpty.png"
                alt="Paper Note"
                style="width: 2em"
                [matTooltip]="'Kommentar erstellen'"
              />
            </ng-container>
          </ng-template>
        </mat-cell>
        <ng-container *ngIf="hasRequiredRole(role.sensor_view)">
          <div
            class="sensor-grid"
            *ngIf="station.sensors.length > 0"
          >
            <div
              class="sensor-grid__cell sensor-value-cell"
              *ngFor="
                let sensorRow of getSensorRows(station); trackBy: trackBySensorRow
              "
            >
              <div *ngIf="sensorRow.sensor.comment; else emptyCommentIcon">
                <img
                  (click)="
                    openDialogCommentSensor(
                      sensorRow.sensor,
                      station.stationId,
                      hasRequiredRole(role.comment_edit)
                    )
                  "
                  [id]="'sensor-comment-' + sensorRow.sensor.sensorType"
                  src="assets/icons8Note.png"
                  alt="Paper Comment"
                  style="width: 2em"
                  [matTooltip]="sensorRow.sensor.comment.text"
                />
                <ng-container *ngIf="hasRequiredRole(role.comment_delete)">
                  <img
                    (click)="archiveRemarkCommentSensor(sensorRow.sensor)"
                    src="assets/icons8-trash-96.png"
                    alt="Trash/Delete"
                    style="width: 2em; margin-left: 0.2em"
                    [matTooltip]="'Kommentar löschen'"
                  />
                </ng-container>
              </div>
              <ng-template #emptyCommentIcon>
                <ng-container *ngIf="hasRequiredRole(role.comment_edit)">
                  <img
                    (click)="openDialogCommentSensor(sensorRow.sensor, station.stationId)"
                    [id]="'sensor-comment-' + sensorRow.sensor.sensorType"
                    src="assets/icons8NoteEmpty.png"
                    alt="Paper Comment"
                    style="width: 2em"
                    [matTooltip]="'Kommentar erstellen'"
                  />
                </ng-container>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </td>
    </ng-container>
    <ng-container
      *ngIf="hasRequiredRole(role.image_view)"
      matColumnDef="images"
    >
      <th mat-header-cell *matHeaderCellDef>Bilder</th>
      <td class="sensors" mat-cell *matCellDef="let station">
        <mat-cell [id]="'render-test'">
          <div *ngIf="station.imageCount > 0">
            <img
              [id]="'station-images-' + station.stationId"
              src="assets/icons8imagefile.png"
              alt="Images"
              style="width: 2em"
              [matTooltip]="
                station.imageCount +
                (station.imageCount > 1 ? 'Bilder' : ' Bild')
              "
            />
          </div>
        </mat-cell>
      </td>
    </ng-container>
    <ng-container *ngIf="hasRequiredRole(role.station_info_view)" matColumnDef="info">
      <th mat-header-cell *matHeaderCellDef>Info</th>
      <td mat-cell *matCellDef="let station" class="info-cell">
        <ng-container *ngIf="imageUrlsOnce$ | async as imageUrls; else loading">
          <div class="info-icons-vertical">
            <ng-container *ngFor="let entry of station.stationInfoEntrys; trackBy: trackByInfoEntry">
              <ng-container *ngIf="entry.active && entry.stationInfo.active">
                <img
                  [src]="
                    getImageUrlForLabel(entry.stationInfo.infoLabel, imageUrls)
                  "
                  width="40"
                  height="40"
                  [matTooltip]="entry.stationInfo.infoLabel"
                  (error)="onImageError($event)"
                />
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #loading>
          <div class="loading-container">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        </ng-template>
      </td>
    </ng-container>
    <tr
      mat-header-row
      *matHeaderRowDef="columnsToDisplayStation; sticky: true"
    ></tr>
    <tr
      mat-row
      *matRowDef="let stations; columns: columnsToDisplayStation"
    ></tr>
  </table>
  <mat-paginator
    [length]="length"
    [pageSizeOptions]="pageSizes"
    [pageSize]="currentPageSize"
    [pageIndex]="pageNo"
    (page)="onPageSizeChange($event)"
  ></mat-paginator>
</div>
